import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f21687b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "radio-wrapper" }
const _hoisted_2 = ["name", "id", "value", "checked"]
const _hoisted_3 = ["for", "tabindex"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("svg", {
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12"
  }, [
    /*#__PURE__*/_createElementVNode("circle", {
      class: "radio-circle",
      cx: "6",
      cy: "6",
      r: "5",
      fill: "white",
      stroke: "white",
      "stroke-width": "1"
    })
  ])
], -1))
const _hoisted_5 = { class: "checkboxtext" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("input", {
      class: "inp-cbx2 form-control",
      name: _ctx.name,
      type: "radio",
      style: {"display":"none"},
      id: _ctx.guid,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
      value: _ctx.value,
      checked: _ctx.checked
    }, null, 8, _hoisted_2),
    _createElementVNode("label", {
      class: "cbx2 mb-0",
      for: _ctx.guid,
      tabindex: _ctx.tabIndex
    }, [
      _hoisted_4,
      _createElementVNode("span", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.label), 1)
        ], true)
      ])
    ], 8, _hoisted_3)
  ]))
}